import React from 'react';
export function PartnerSection() {
    return (
        <>
            <section id="partner" className="cta">
                <div className="wrap">
                    <div className="term">
                        <div className="bar"><span>07 / Partner with us</span>
                            <span className="r"><i></i><i></i><i></i></span>
                        </div>
                        <div className="body">
                            <span className="ghostnum">2026</span>
                            <div className="prompt"><span>h2o / partnerships —</span>
                                <span>open</span>
                                <span className="cur"></span>
                            </div>
                            <h2>Your brand.<br />
                                <em>Next market.</em>
                            </h2>
                            <p>Looking for an Australian distribution partner who can own the route to market?</p>
                            <a className="btn-ink" href="#">Start a distribution conversation <span>→</span></a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}